import { I18nProvider as I18nProviderApp } from '../locales/i18n-context';

export interface I18nProviderProps {
  readonly children?: React.ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  return (
    <I18nProviderApp>
      <>{children}</>
    </I18nProviderApp>
  );
}
